import {inject, Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {ToastService} from 'bs-components';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class MessageHandlerService {
  private readonly toastService = inject(ToastService);
  private readonly translateService = inject(TranslateService);


  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  public handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      console.error(error);
      const operationTranslation = this.translateService.instant(operation);
      if (error.status === 503) {
        this.log('error', `${operationTranslation} - Server not available`, 3);
      } else {
        this.log(
          'error',
          `${operationTranslation} - ${error.error?.detail}`,
          3
        );
      }

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a message with the MessageService */
  public log(title: string, content: string, level: number) {
    const titleTranslation = this.translateService.instant(title);
    const contentTranslation = this.translateService.instant(content);

    switch (level) {
      case 0:
        this.toastService.showInfo(titleTranslation, contentTranslation);
        break;
      case 1:
        this.toastService.showSuccess(titleTranslation, contentTranslation);
        break;
      case 2:
        this.toastService.showWarning(titleTranslation, contentTranslation);
        break;
      case 3:
        this.toastService.showError(titleTranslation, contentTranslation);
        break;
    }
  }
}
